export default __webpack_public_path__ + "static/image10-d59a6037bcec42dcfd5be2acc811ec78.jpeg";